import { render, staticRenderFns } from "./ChatBubble.vue?vue&type=template&id=6e208f96"
import script from "./ChatBubble.vue?vue&type=script&lang=js"
export * from "./ChatBubble.vue?vue&type=script&lang=js"
import style0 from "./ChatBubble.vue?vue&type=style&index=0&id=6e208f96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports